import { em, math } from 'polished'
import styled from 'styled-components'

import Icon from 'components/Icon'
import { Col } from 'styles/components/layout'
import { Text } from 'styles/components/typography'
import { unstyleButton } from 'styles/mixins'

const arrowWrapperH = em(30)
const arrowH = em(100)
const arrowW = em(22)

export const Button = styled.button`
  ${unstyleButton};
  text-align: left;
`

export const TitleBox = styled.div`
  padding-bottom: ${em(10)};
  max-width: ${em(360)};
`

export const Title = styled(Text)`
  display: inline-block;
`

export const ColStyled = styled(Col)`
  ${p => p.theme.mq.upMd} {
    margin-left: ${100 * (1 / 12)}%;
  }

  ${p => p.theme.mq.upLg} {
    margin-left: ${100 * (2 / 12)}%;
  }
`

export const ArrowWrapper = styled.div`
  position: relative;
  left: ${math(`-${em(22)}/2 + ${em(2)}`)};
  overflow: hidden;
  width: 100%;
  height: ${arrowWrapperH};

  ${p => p.theme.mq.upMd} {
    height: ${arrowH};
  }
`

export const ArrowBlock = styled.div`
  position: absolute;
  bottom: ${math(`${arrowH} - ${arrowW}`)};
  width: ${arrowH};
  height: ${arrowW};
`

export const StyledIcon = styled(Icon)`
  transform: rotateZ(90deg) translateY(-100%);
  transform-origin: 0 0;
`
